/**
 * A line that opens a fenced block, capturing its fence and info string. A backtick fence's info
 * string can't hold a backtick; such a line is inline code.
 */
export const OPENING_FENCE = /^[ \t]*(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})[ \t]*(\S*)/;

/** Whether `line` closes a block its `marker` opened: only that fence character, at least as many. */
export const isClosingFence = (line: string, marker: string): boolean => {
	const trimmed = line.trim();
	return trimmed.length >= marker.length && [...trimmed].every((char) => char === marker[0]);
};

/**
 * The offset just past the JSON object that starts at `from`, after any whitespace. The model
 * sometimes forgets a chart block's closing fence, and the block's JSON is where it should end.
 */
export const jsonObjectEnd = (text: string, from: number): number | undefined => {
	let index = from;
	while (index < text.length && /\s/.test(text[index] ?? "")) index += 1;
	if (text[index] !== "{") return undefined;
	let depth = 0;
	let inString = false;
	for (; index < text.length; index += 1) {
		const char = text[index];
		if (inString) {
			if (char === "\\") index += 1;
			else if (char === '"') inString = false;
		} else if (char === '"') {
			inString = true;
		} else if (char === "{") {
			depth += 1;
		} else if (char === "}") {
			depth -= 1;
			if (depth === 0) return index + 1;
		}
	}
	return undefined;
};
